import { useEffect } from 'react';
import WOW from "wowjs";
import './App.css';
import { Banner } from './Components/Banner';
import { Cases } from './Components/Cases';
import { Clients } from './Components/Clients';
import { Contact } from './Components/Contact';
import { Footer } from './Components/Footer';
import { Head } from './Components/Head';
import { Onbarding } from './Components/Onbarding';
import { Stats } from './Components/Stats';
import { Testimonials } from './Components/Testimonials';
import { WorkAchievments } from './Components/WorkAchievments';
import { Benefits } from './Components/Benefits';
import { NewProcess } from './Components/NewProcess';
import "animate.css";

function App() {
  useEffect(() => {
    new WOW.WOW({ live: false }).init();
  }, []);

  return (
    <>
      <Head />
      <Banner />
      <Clients />
      <Stats />
      <WorkAchievments />
      {/* <Process /> */}
      <NewProcess />
      <Benefits />
      <Onbarding />
      <Cases />
      <Testimonials />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
